var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00154781 0.851445C0.00115776 0.652853 0.0707521 0.460393 0.198254 0.307477C0.27005 0.221413 0.358228 0.150271 0.457733 0.0981246C0.55724 0.0459785 0.666118 0.0138536 0.778134 0.00358969C0.890152 -0.00667418 1.00311 0.00512483 1.11053 0.0383107C1.21795 0.0714965 1.31773 0.125416 1.40415 0.196984L5.98827 4.00476L10.5809 0.332976C10.6684 0.262375 10.7691 0.209651 10.8771 0.177836C10.9852 0.146021 11.0985 0.135741 11.2106 0.147589C11.3226 0.159437 11.4312 0.193177 11.5301 0.246872C11.629 0.300566 11.7163 0.373156 11.7868 0.460468C11.8647 0.548409 11.9234 0.651394 11.9593 0.76296C11.9952 0.874526 12.0076 0.992266 11.9955 1.10879C11.9835 1.22531 11.9473 1.3381 11.8893 1.44008C11.8313 1.54206 11.7528 1.63102 11.6586 1.70139L6.52708 5.80665C6.37404 5.93166 6.18209 6 5.98399 6C5.7859 6 5.59395 5.93166 5.44091 5.80665L0.309436 1.5569C0.205936 1.47164 0.12412 1.36333 0.0706253 1.24076C0.0171309 1.11818 -0.00653458 0.984807 0.00154781 0.851445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.eec3c28bc67a71b70ff22e07417e4383.svg";
export { ForwardRef as ReactComponent };